import * as TyreTakeoverOrderModels from '../../models/tyre-takeover-order/tyre-takeover-order';
import { TyreTakeoverOrderSearchModel } from '../../models/tyre-takeover-order/tyre-takeover-orderSearch';
import * as Models from '../../models/commonModels';

export class GetStatusDictionary {
  static readonly type = '[TyreTakeover] Get Status Dictionary';
  constructor() { }
}

export class GetList {
  static readonly type = '[TyreTakeover] List';
  constructor(public Search: TyreTakeoverOrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[TyreTakeover] Set Search';
  constructor(public Search: TyreTakeoverOrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[TyreTakeover] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[TyreTakeover] Set List Page';
  constructor(public Search: TyreTakeoverOrderSearchModel) { }
}

export class Set {
  static readonly type = '[TyreTakeover] Set';
  constructor(public Order: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) { }
}

export class Get {
  static readonly type = '[TyreTakeover] Get';
  constructor(public OrderId: Models.RequestModel) { }
}

export class Create {
  static readonly type = '[TyreTakeover] Create';
  constructor(public Order: Models.RequestNewOrder<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) { }
}

export class CreateBulk {
  static readonly type = '[TyreTakeover] Create Bulk';
  constructor(public Order: Models.RequestNewOrder<TyreTakeoverOrderModels.TyreTakeoverOrderBulkModel>) { }
}



export class GetReportFiltered {
  static readonly type = '[TyreTakeover] Report Filtered';
  constructor(public Search: TyreTakeoverOrderSearchModel) { }
}

export class GetReportNFM {
  static readonly type = '[TyreTakeover] Report NFM';
  constructor(public Search: TyreTakeoverOrderSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[TyreTakeover] DisposeSearch';
  constructor() { }
}

export class SetProtocolFile {
  static readonly type = '[TyreTakeover] Set Protocol File';
  constructor(public Order: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>, public File: File) { }
}

export class GetProtocolFile {
  static readonly type = '[TyreTakeover] Get Protocol File';
  constructor(public Order: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) { }
}

export class SetAuthorizationFile {
  static readonly type = '[TyreTakeover] Set Authorization File';
  constructor(public Order: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>, public File: File) { }
}

export class GetAuthorizationFile {
  static readonly type = '[TyreTakeover] Get Authorization File';
  constructor(public Order: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) { }
}

export class DeleteTakeoverDeposite {
  static readonly type = '[TyreTakeover] Delete TakeoverDeposite';
  constructor(public TakeoverDeposite: Models.Request<TyreTakeoverOrderModels.TakeoverDepositesModel>) { }
}

export class AddTakeoverDeposite {
  static readonly type = '[TyreTakeover] Add TakeoverDeposite';
  constructor(public TakeoverDeposite: Models.Request<TyreTakeoverOrderModels.TakeoverDepositesModel>) { }
}

export class HandoverProtocolPdf {
  static readonly type = '[TyreTakeover] HandoverProtocol Pdf';
  constructor(public Order: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) { }
}

export class ProtocolXls {
  static readonly type = '[TyreTakeover] Protocol Xls';
  constructor(public Order: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>) { }
}

export class ImportTyresFile {
  static readonly type = '[TyreTakeover] Import Tyres File';
  constructor(public Order: Models.Request<TyreTakeoverOrderModels.TyreTakeoverOrderModel>, public File: File) { }
}

export class ImportOrders {
  static readonly type = '[TyreTakeover] Import Orders';
  constructor(public Order: Models.RequestNewOrder<TyreTakeoverOrderModels.TyreTakeoverOrderModel>, public File: File) { }
}
